<template lang="pug">
  section(class="separable")
    div.marginTop(class="container")
      el-row
        el-col(:span="24")
          div(class="card")
            div(class="card-header").titulo Listagem de conversas
            div(class="card-body")
              el-row
                .divider
              .table-pointer
                el-table(
                  :data="conversas"
                  :default-sort = "{ prop: 'id', order: 'descending' }",
                  @sort-change="sort",

                  style="cursor: pointer"
                )
                  el-table-column(
                    min-width="40"
                  )
                  el-table-column(
                    label='Assunto',
                    prop='assuntoDescricao'
                    min-width="300"
                    sortable
                  )
                  el-table-column(
                    label='Responsável',
                    min-width='300',
                    prop='mensagemList[0].destinatario.pessoaFisica.nome',
                    :formatter='formatNome'
                    sortable
                  )
                  el-table-column(
                    label='Interessado',
                    min-width='300',
                    prop='mensagemList[0].remetente.pessoaFisica.nome'
                    sortable
                  )
                  el-table-column(
                    label='Data de início da conversa',
                    sortable
                    min-width='210',
                    prop='dataInicioConversa',
                    :formatter='formatDataInicioConversa'
                  )
                  el-table-column(
                    label='Data da última resposta',
                    sortable
                    min-width='210',
                    prop='dataUltimaMensagem',
                    :formatter='formatDataResposta'
                  )
                  el-table-column(
                    label='Status',
                    min-width='100',
                    prop='statusDescricao'
                    sortable
                  )
                  el-table-column(
                    label='Ações',
                    min-width='100'
                    prop='id'
                  )
                    template(slot-scope='scope')
                      el-dropdown(trigger="click", size="small")
                        el-button(type='primary', size="mini")
                          | Ações
                          i.el-icon-arrow-down.el-icon--right
                        el-dropdown-menu(slot='dropdown')
                          div
                            el-dropdown-item(v-if="scope.row.status === 'RESPONDIDA' || scope.row.status === 'ENCERRADA'")
                              .flex(@click="$router.push({name: 'ouvidoria/conversa/visualizar/', params: { idConversa: scope.row.id }})")
                                i.fas.fa-eye
                                |&nbsp; Visualizar conversa
                            el-dropdown-item(v-if="scope.row.status === 'AGUARDANDO_RESPOSTA_INTERNO'")
                              .flex(@click="$router.push({name: 'ouvidoria/conversa/responder/', params: { idConversa: scope.row.id }})")
                                i.fal.fa-reply
                                |&nbsp; Responder
</template>

<script>
import utils from '@/utils/utils'

export default {
  props: {
    conversas: {
      type: Array,
      required: true
    }
  },

  methods: {
    formatDataResposta (data) {
      if (!data.dataUltimaMensagem) {
        return '-'
      }
      return utils.formatDate(data.dataUltimaMensagem, 'DD/MM/YYYY HH:mm')
    },

    formatDataInicioConversa (data) {
      return utils.formatDate(data.dataInicioConversa, 'DD/MM/YYYY HH:mm')
    },

    sort (data) {
      const ordenacaoFiltro = {
        ordenacao: '',
        tipo: ''
      }

      switch (data.prop) {
        case 'ultimaMensagem.dataEnviada':
          ordenacaoFiltro.ordenacao = 'ultimaMensagem.dataEnviada'
          break
        case 'statusDescricao':
          ordenacaoFiltro.ordenacao = 'statusDescricao'
          break
        default:
          ordenacaoFiltro.ordenacao = 'mensagemList[0].dataEnviada'
      }

      if (data.order === 'ascending') {
        ordenacaoFiltro.tipo = 'ASC'
      } else {
        ordenacaoFiltro.tipo = 'DESC'
      }

      this.$emit('sort', { ...ordenacaoFiltro })
    },
    formatNome (dados) {
      let destinatario

      if (dados.mensagemList.length > 1 && dados.mensagemList[dados.mensagemList.length - 1].destinatario) {
        destinatario = dados.mensagemList[dados.mensagemList.length - 1].remetente
      }

      if (destinatario && destinatario.pessoaFisica) {
        return destinatario.pessoaFisica.nome
      } else {
        return '-'
      }
    }

  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.titulo {
  color: #424242;
  font-size: 1.5rem;
  padding-bottom: 0;
}
.divider {
  border: 1px solid $border-color;
  margin-bottom: 2px;
}
.button {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/components/ListagemConversas.vue